import React from 'react'
import { BottomArrowIcon, NotAvailableIcon, TrophyIcon, SacIcon } from 'assets'
import CircularProgressBar from 'components/circularProgressBar/CircularProgressBar'
import { colors } from 'styles/colors'

interface PaymentSummary {
    percentage?: number
    balance?: number
    allEnrollment?: number
}

interface PaymentProgressIconProps {
    paymentSummary?: PaymentSummary
    isVisitedClient?: boolean
    isFinisher?: boolean
    size?: number
}

export const PaymentProgressIcon = ({
    paymentSummary,
    isVisitedClient = false,
    isFinisher = false,
    size = 30
}: PaymentProgressIconProps) => {
    const {
        percentage = 0,
        balance = 0,
        allEnrollment = 0
    } = paymentSummary ?? {}

    const gaugeColor = isVisitedClient ? colors.primary : colors.mediumGrey
    const trophyColor = isVisitedClient ? colors.purple : colors.grey

    const renderGauge = (percent: number, color: string) => (
        <CircularProgressBar
            percentage={percent}
            gaugeColor={color}
            size={size}
            aria-label="progress-gauge"
        />
    )

    if (balance < 0) {
        return (
            <BottomArrowIcon
                aria-label="bottom-arrow-icon"
                color={colors.lightRed}
            />
        )
    }

    if (
        percentage >= 100 ||
        (allEnrollment === 0 && balance > 0 && isFinisher)
    ) {
        return <TrophyIcon aria-label="trophy-icon" color={trophyColor} />
    }

    if (allEnrollment === 0 && balance > 0) {
        return renderGauge(25, gaugeColor)
    }

    if (allEnrollment === 0 && balance === 0) {
        return (
            <NotAvailableIcon
                aria-label="not-available-icon"
                height={String(size)}
                width={String(size)}
                color={colors.grey}
            />
        )
    }

    if (allEnrollment > 0 && balance === 0) {
        return renderGauge(100, colors.lightGrey)
    }

    if (percentage >= 75) return renderGauge(75, gaugeColor)
    if (percentage >= 50) return renderGauge(50, gaugeColor)
    if (percentage >= 1) return renderGauge(25, gaugeColor)

    return (
        <SacIcon
            aria-label="sac-icon"
            color={isVisitedClient ? colors.primary : colors.grey}
        />
    )
}
